// @flow
/* eslint-disable ta-code-conventions/has-matching-storydoc */
/* eslint-disable ta-code-conventions/has-matching-test */

import React from 'react';
import classNames from '@ta/common.classnames';
import { useLocalize } from '@ta/platform.i18n';
import { Icon } from '@ta/styleguide.icon';
import styles from './NextButton.css';

type Props = {|
  iconName?: string,

  /**
   * If true, the next button cannot be tapped. This is usually true if the current step is
   * required and hasn't been filled out yet.
   */
  disabled?: boolean,

  onClick: () => mixed,

  /** Increase the button bottom css to be higher in the modal */
  increasedBottom?: boolean,
|};

/**
 * A custom button shown to advance to the next step of an onboarding flow
 */
const NextButton = ({
  iconName = 'arrow-right',
  disabled = false,
  onClick,
  increasedBottom = false,
}: Props) => {
  const { localize } = useLocalize();
  return (
    <div className={classNames(styles.container, { [styles.increasedBottom]: increasedBottom })}>
      <button
        className={styles.nextButton}
        onClick={() => onClick()}
        disabled={disabled}
        aria-label={localize.string('common_Next') /* Next */}
      >
        <Icon name={iconName} />
      </button>
    </div>
  );
};

export default NextButton;
